import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  return {
    container: {
      paddingBottom: "4rem",
    },
    actionsContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0.6rem",
      paddingTop: "0.8rem",
      position: "sticky",
      zIndex: "1000",
      paddingRight: "1.3rem",
      borderRadius: "14px",
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
    },
    headerCard: {
      borderRadius: "16px",
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
    },
    profileContainer: {
      display: "flex",
    },
    profileAvatar: {
      height: "80px",
      width: "80px",
      border: "2px solid #e6e8eb",
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      fontSize: "1.6rem",
      fontWeight: 600,
    },
    criticalAvatar: {
      height: "80px",
      width: "80px",
      border: "2px solid #f44336",
      backgroundColor: theme.palette.secondary.main,
      color: "#fff",
      fontSize: "1.6rem",
      fontWeight: 600,
    },
    profileInfoContainer: {
      marginLeft: "30px",
      width: "100%",
    },
    caseInfoContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: "8px",
      justifyContent: "space-between",
    },
    name: {
      fontSize: "22px",
      fontWeight: 700,
      color: theme.palette.text.primary,
      lineHeight: 1.3,
    },
    criticalName: {
      color: "#f44336",
    },
    caseNumberConatiner: {
      marginLeft: "3.1rem",
    },
    caseNumber: {
      fontSize: "0.85rem",
      fontWeight: 600,
      color: theme.palette.primary.dark,
      backgroundColor: "rgba(17, 98, 254, 0.1)",
      padding: "4px 12px",
      borderRadius: "8px",
    },
    switchCaseButton: {
      textTransform: "none",
      fontWeight: 600,
      borderRadius: "8px",
      marginRight: theme.spacing(1),
      padding: "2px 10px",
    },
    editBoxContainer: {
      marginTop: "1rem",
      marginBottom: "15px",
      width: "100%",
    },
    editBoxButtonContainer: {
      display: "flex",
      marginTop: "8px",
      justifyContent: "flex-end",
    },
    editBoxSaveButton: {
      marginLeft: "0.5rem",
    },
    descContainer: {
      display: "flex",
      alignItems: "center",
      marginTop: "0.7rem",
    },
    descLabel: {
      color: theme.palette.text.secondary,
      fontSize: "0.95rem",
      fontWeight: 600,
    },
    descText: {
      fontSize: "15px",
      marginTop: "0.5rem",
      color: theme.palette.text.primary,
    },
    descEditButton: {
      marginTop: "15px",
    },
    createdByContainer: {
      margin: "0.5rem 0rem",
    },
    createdByText: {
      fontSize: "12px",
      fontStyle: "italic",
      color: "#6f6f6f",
    },
    optionsContainer: {
      display: "flex",
      alignItems: "center",
    },
    optionAvatar: {
      marginRight: "12px",
    },
    optionText: {
      marginRight: "5px",
    },
    topButtonContainer: {
      position: "absolute",
      top: "1rem",
      left: "1rem",
      right: "1rem",
      display: "flex",
      justifyContent: "space-between",
    },
    backButton: {
      textTransform: "capitalize",
      marginLeft: "6px",
      marginRight: "6px",
    },
    buttonsInnerContainer: {
      display: "flex",
      marginRight: "-5px",
    },
    selectContainer: {
      width: "150px",
    },
    criticalContainer: {
      marginRight: "0px",
    },
    topDivider: {
      position: "absolute",
      top: "4rem",
      width: "100%",
    },
    timelineDivider: {
      marginTop: "15px",
      marginBottom: "20px",
    },
    sortButtonsContainer: {
      position: "absolute",
      right: "1rem",
      top: "0px",
    },
    sortButton: {
      border: "none !important",
      borderRadius: "10px !important",
      margin: "0 2px !important",
      minWidth: "120px",
      padding: "7px 18px",
      textTransform: "none",
      fontWeight: 500,
      fontSize: "0.9rem",
      color: theme.palette.text.primary,
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "rgba(30, 123, 187, 0.08)",
      },
    },
    addNoteHeadingContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: "1.2rem",
      marginLeft: "1rem",
      marginBottom: "0.5rem",
    },
    addNoteContainer: {
      display: "flex",
      alignItems: "center",
      marginLeft: "-5px",
    },
    addNoteLabel: {
      fontSize: "1.2rem",
      fontWeight: "400",
      marginLeft: "0.2rem",
    },
    toggleButtonsContainer: {
      marginRight: "1rem",
      "& .MuiToggleButtonGroup-root": {
        backgroundColor: "#ffffff",
        border: "1px solid #e6e8eb",
        borderRadius: "12px",
        padding: "5px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
      },
    },
    tabIcon: {
      fontSize: "1.15rem",
      marginRight: "8px",
    },
    sortButtonLabel: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    doctorsListContainer: {
      marginTop: "1.5rem",
    },
    input: {
      paddingTop: "10px!important",
      paddingBottom: "10px!important",
    },
    hcLabel: {
      fontSize: "12px",
      marginBottom: "0.5rem",
      color: "#727272",
    },
    addNoteInfo: {
      fontWeight: "bold",
      fontSize: "14px",
      color: "rgba(0, 0, 0, 0.6)",
    },
    buttonLebelContainer: {
      display: "flex",
      alignItems: "center",
    },
    noContentContainer: {
      textAlign: "center",
      marginTop: "3rem",
    },
    noLabel: {
      fontSize: "1.5rem",
      opacity: "0.2",
    },
    selected: {
      color: "white !important",
      backgroundColor: `${theme.palette.primary.main} !important`,
      boxShadow: "0 2px 6px rgba(30, 123, 187, 0.35)",
      "&:hover": {
        backgroundColor: `${theme.palette.primary.dark} !important`,
      },
    },
    text: {
      color: "#000",
    },
    formContainer: {
      width: "100%",
    },
    doctorChip: {
      marginRight: "5px",
      marginBottom: "5px",
    },
    prescriptionButton: {
      border: "none !important",
      borderRadius: "10px !important",
      margin: "0 2px !important",
      minWidth: "120px",
      padding: "7px 18px",
      textTransform: "none",
      fontWeight: 500,
      fontSize: "0.9rem",
      color: theme.palette.text.primary,
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "rgba(30, 123, 187, 0.08)",
      },
    },
    prescriptionContainer: {
      paddingLeft: "1rem",
      paddingRight: "1rem",
    },
    addButton: {
      textAlign: "right",
      paddingRight: "1.3rem",
    },
  };
});
